module.exports = __webpack_public_path__ + "static/img/nav_bg.24855c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav_bg.svg
// module id = F7+U
// module chunks = 1